export default {
  selectedPlanAmountState: state => state.selectedPlanAmount
}
